/*
Site Video
*/

class SiteVideo extends HTMLElement {
  constructor() {
    super();
    this.video = null;
  }

  connectedCallback() {
    this.video = this.querySelector("video");
    this.observe();
  }

  observe() {
    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((video) => {
          const $video = video.target;
          if (video.isIntersecting) {
            if ($video.readyState === 4 && this.dataset.autoplay !== "false") {
              $video.play();
            } else {
              [].slice
                .call($video.querySelectorAll("source"))
                .forEach((source) => {
                  source.src = source.dataset.src;
                });

              $video.load();
            }
          } else {
            if (!$video.paused) {
              $video.pause();
            }
          }
        });
      });

      videoObserver.observe(this.video);
    }
  }

  play() {
    this.video.play();
  }

  pause() {
    this.video.pause();
  }
}

customElements.define("site-video", SiteVideo);

/*
Site Image
*/

class SiteImage extends HTMLElement {
  constructor() {
    super();
    this.observe();
  }

  observe() {
    if ("IntersectionObserver" in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(function (image) {
          const $image = image.target;
          if (image.isIntersecting) {
            $image.classList.add("active");
            imageObserver.unobserve($image);
            $image.classList.add("active");
            imageObserver.unobserve($image);
          }
        });
      });

      imageObserver.observe(this.querySelector(".mediabox"));
    }
  }
}

customElements.define("site-image", SiteImage);

/*
Marketing Scroller
*/

class MarketingScroller extends HTMLElement {
  constructor() {
    super();
    this.activateScroller();
  }

  activateScroller() {
    let scroller = 0;
    let tickerContainer = this.querySelector(".marketing-ticker__container");

    const options = {};

    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.onscroll = function () {
            let direction = this.oldScroll > this.scrollY;
            this.oldScroll = this.scrollY;

            if (direction) {
              scroller = scroller - 1;
            } else {
              scroller = scroller + 1;
            }

            let scrollerValue = scroller * 4;
            tickerContainer.style.transform = `translateX(${
              scrollerValue + 112
            }px)`;
          };
        }
      });
    }, options);

    observer.observe(tickerContainer);
  }
}

customElements.define("marketing-scroller", MarketingScroller);

/*
Swiper Carousel
*/

class SwiperCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.id = this.dataset.id;
    this.initCarousel(this.data);
    this.setupListeners();
  }

  setupListeners() {
    const pagers = this.querySelectorAll(".carousel-pager");
    const prev = this.querySelector(".carousel-prev");
    const next = this.querySelector(".carousel-next");

    if (this.swiper.activeIndex === 0) {
      prev.classList.add("carousel__arrow--deactive");
    }

    this.swiper.on("slideChange", () => {
      pagers.forEach((el) => el.classList.remove("active"));
      const next = pagers[this.swiper.realIndex];
      if (next) {
        next.classList.add("active");
      }
    });

    Array.from(pagers).forEach((pager, i) => {
      pager.addEventListener("click", (e) => {
        this.swiper.slideTo(i + 1);
      });
    });

    if (prev) {
      prev.addEventListener("click", () => {
        let realIndex = this.swiper.activeIndex;

        // deactivePrevArrow(realIndex);

        if (this.swiper) {
          this.swiper.slidePrev();
        }
      });
    }

    if (next) {
      next.addEventListener("click", () => {
        let realIndex = this.swiper.activeIndex;

        // deactiveNextArrow(realIndex);

        if (this.swiper) {
          this.swiper.slideNext();
        }
      });
    }

    this.swiper.on("slideChange", function (e) {
      const idx = e.realIndex;
      const thumbs = document.querySelectorAll(".swiper__thumb");
      thumbs.forEach((thumb) => thumb.classList.remove("active"));

      if (thumbs[idx]) {
        thumbs[idx].classList.add("active");
      }
    });

    this.addEventListener("click", (e) => {
      const button = e.target.closest("button");
      if (button && button.matches(".swiper__thumb")) {
        const thumbs = document.querySelectorAll(".swiper__thumb");
        const idx = Array.from(thumbs).indexOf(button);
        thumbs.forEach((thumb) => thumb.classList.remove("active"));
        button.classList.add("active");
        this.swiper.slideTo(idx + 1);
      }
    });
  }

  initCarousel(
    config = {
      slidesPerView: 1,
      loop: true,
      breakpoints: {
        1024: {
          slidesPerView: 3,
        },
      },
      spaceBetween: 19,
    }
  ) {
    this.swiper = new Swiper(`#${this.id} .swiper`, config);
  }
}

customElements.define("swiper-carousel", SwiperCarousel);

/*
Reviews Summary
*/

class ReviewsSummary extends HTMLElement {
  connectedCallback() {
    const appKey = window.okendo.appKey;
    const productId = this.dataset.productId;
    const request = window.fetch(
      `https://api.okendo.io/v1/stores/${appKey}/products/shopify-${productId}/review_aggregate`
    );
    const json = request.then((response) => response.json());

    json
      .then((data) => {
        const rating =
          Number(data?.reviewAggregate?.ratingAndReviewValuesTotal) || 0;
        const count = Number(data?.reviewAggregate?.ratingAndReviewCount) || 0;
        const score = parseFloat(rating / count).toFixed(1);

        if (isNaN(score) || !score) {
          return;
        }

        const productReviews = this.querySelector(
          `#favorite-product__${productId}`
        );
        const reviewCountElement = this.querySelector(`.overall-rating`);
        reviewCountElement.innerHTML = score;
        productReviews.classList.remove("hidden");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("reviews-summary", ReviewsSummary);

/*
Carousel Pager
*/

class CarouselPager extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const pagerButtons = Array.from(this.querySelectorAll("button"));

    if (!pagerButtons.length > 1) {
      console.warn("No need for a pager with only one item!");
    }

    pagerButtons.forEach((pager, i) => {
      pager.addEventListener("click", (e) => {
        const carousel = e.target.closest("site-carousel");

        if (carousel) {
          carousel.slideTo(i);
        } else {
          console.error(
            "<carousel-pager> needs to be a child of <site-carousel>"
          );
        }
      });
    });
  }
}

customElements.define("carousel-pager", CarouselPager);

/*
 * Site Carousel
 */

class SiteCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const config = this.dataset.config
      ? JSON.parse(this.dataset.config)
      : { slidesPerView: 3, spaceBetween: 20 };

    this.swiper = new Swiper(`#${this.dataset.id} .swiper`, config);
    this.handleSlideChange();
  }

  previous() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  next() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  slideTo(i) {
    if (this.swiper) {
      this.swiper.slideTo(i);
    }
  }

  handleSlideChange() {
    // we can have multiple pagers in one carousel
    const pagers = Array.from(this.querySelectorAll("carousel-pager"));

    if (this.swiper) {
      this.swiper.on("slideChange", () => {
        pagers.forEach((pager) => {
          const buttons = Array.from(pager.querySelectorAll("button"));
          const nextPager = buttons[this.swiper.realIndex];

          buttons.forEach((button) => button.classList.remove("active"));
          nextPager.classList.add("active");
        });
      });
    }
  }
}

customElements.define("site-carousel", SiteCarousel);

/*
Accordion Item
*/

class AccordionItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const summary = this.querySelector("summary");

    summary.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeExpandedAccordions();
      this.toggle();
    });

    if (this.dataset.open === "true") {
      this.open(this);
    }
  }

  closeExpandedAccordions() {
    this.parentElement.querySelectorAll("accordion-item").forEach((item) => {
      const details = item.querySelector("details");
      if (details.open) {
        this.close(item);
      }
    });
  }

  toggle() {
    const details = this.querySelector("details");

    if (details.open) {
      this.close(this);
    } else {
      this.open(this);
    }
  }

  close(item) {
    const icon = item.querySelector("svg");
    const details = item.querySelector("details");
    const content = item.querySelector(".content");

    content.style.maxHeight = `${content.scrollHeight}px`;
    content.getBoundingClientRect();
    icon.style.transform = "rotate(0deg)";
    content.style.maxHeight = "0px";
    setTimeout(() => {
      details.open = false;
    }, 300);
  }

  getHeight(el) {
    const clone = el.cloneNode(true);
    clone.style.height = "auto";
    clone.style.visibility = "hidden";
    clone.style.position = "absolute";
    clone.style.top = "-9999px";
    document.body.appendChild(clone);
    const height = clone.scrollHeight;
    document.body.removeChild(clone);
    return height;
  }

  open(item) {
    const icon = item.querySelector("svg");
    const details = item.querySelector("details");
    const content = item.querySelector(".content");

    details.open = true;
    content.style.maxHeight = "none";
    const contentHeight = content.scrollHeight;
    content.style.maxHeight = "0px";
    icon.style.transform = "rotate(180deg)";

    content.getBoundingClientRect();
    content.style.maxHeight = `${contentHeight}px`;
  }
}

customElements.define("accordion-item", AccordionItem);

/*
Main Article
*/

class MainArticle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupHeaderScroll();
  }

  setupHeaderScroll() {
    const title = this.querySelector(".scroll-title");

    window.addEventListener("scroll", () => {
      const scrollY = window.scrollY || window.pageYOffset;

      title.classList.toggle("active", scrollY >= 180);
    });
  }
}

customElements.define("main-article", MainArticle);
